import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  FaHome, FaUsers, FaCalendarAlt, FaBuilding, FaRobot, 
  FaBookOpen, FaCreditCard, FaEnvelope, FaChartBar, 
  FaCog, FaSignOutAlt, FaChevronDown, FaChevronRight,
  FaUserFriends, FaUserTag, FaUserTie, FaPlus, FaList,
  FaClipboardList, FaCheck, FaTimes, FaHistory,
  FaFileInvoiceDollar, FaUndo, FaFileAlt, FaPaperPlane,
  FaCheckCircle
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import '../../assets/css/layout/admin/AdminSidebar.css';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (menuName) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout from admin panel?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7fd3c1',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('adminToken');
        Swal.fire({
          title: 'Logged Out!',
          text: 'You have been logged out successfully.',
          icon: 'success',
          confirmButtonColor: '#7fd3c1'
        });
        navigate('/admin/login');
      }
    });
  };

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    {
      title: 'Dashboard',
      icon: <FaHome />,
      path: '/admin/dashboard'
    },
    {
      title: 'Sub Admin',
      icon: <FaUserFriends />,
      path: '/admin/sub-admin'
    },
    {
      title: 'User Management',
      icon: <FaUsers />,
      path: '/admin/users/all'
      
    },
    {
      title: 'Venue Management',          // ✅ title add kiya
      icon: <FaBuilding />,         // ✅ icon add kiya
      path: '/admin/venues/list'    // ✅ sirf path — no subMenu
    },
    {
  title: 'Booking Management',
  icon: <FaBookOpen />,
  path: '/admin/bookings/bookingmanagement'
},
 {
  title: 'Payment Management',
  icon: <FaCreditCard />,
  subMenu: [
    {
      title: 'Payment History',
      icon: <FaHistory />,
      path: '/admin/payments/history'
    },
    {
      title: 'Refund Request',
      icon: <FaUndo />,
      path: '/admin/payments/refunds'
    }
  ]
},
    {
      title: 'Packages Management',
      icon: <FaChartBar />,
      path: '/admin/packages'
    },
    {
      title: 'Services Management',
      icon: <FaChartBar />,
      path: '/admin/services'
    },
    {
      title: 'Blogs Management',
      icon: <FaChartBar />,
      path: '/admin/blogs'
    },
    // {
    //   title: 'Invitation template',
    //   icon: <FaEnvelope />,
    //   path: '/admin/invitationstemplate'
    // },
    {
      title: 'Event Types',
      icon: <FaCalendarAlt />,
      path: '/admin/event-type'
    },
    {
      title: 'Chat',
      icon: <FaEnvelope />,
      path: '/admin/chat'
    },
    {
      title: 'Help & Support',
      icon: <FaCog />,
      path: '/admin/SupportTickets'
    }
  ];

  return (
    <div className="admin-sidebar-container">

      {/* Sidebar Header */}
      <div className="admin-sidebar-header">
        <Link to="/" className="admin-sidebar-logo" style={{ textDecoration: 'none' }}>
          <div className="admin-sidebar-logo-icon">
            <span className="admin-sidebar-logo-letter">E</span>
          </div>
          <div className="admin-sidebar-logo-text">
            <h4 className="admin-sidebar-title">EVENT MANAGEMENT</h4>
            <p className="admin-sidebar-subtitle">Admin Panel</p>
          </div>
        </Link>
      </div>

      {/* Sidebar Menu */}
      <div className="admin-sidebar-menu">
        {menuItems.map((item, index) => (
          <div key={index} className="admin-sidebar-menu-item">

            {item.subMenu ? (
              // ── MENU WITH SUBMENU ──
              <>
                <div
                  className={`admin-sidebar-link ${openMenus[item.title] ? 'admin-sidebar-active' : ''}`}
                  onClick={() => toggleMenu(item.title)}
                >
                  <span className="admin-sidebar-icon">{item.icon}</span>
                  <span className="admin-sidebar-text">{item.title}</span>
                  <span className="admin-sidebar-arrow">
                    {openMenus[item.title] ? <FaChevronDown /> : <FaChevronRight />}
                  </span>
                </div>

                {openMenus[item.title] && (
                  <div className="admin-sidebar-submenu">
                    {item.subMenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        className={`admin-sidebar-sublink ${isActive(subItem.path) ? 'admin-sidebar-active' : ''}`}
                      >
                        <span className="admin-sidebar-icon">{subItem.icon}</span>
                        <span className="admin-sidebar-text">{subItem.title}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // ── SIMPLE LINK ──
              <Link
                to={item.path}
                className={`admin-sidebar-link ${isActive(item.path) ? 'admin-sidebar-active' : ''}`}
              >
                <span className="admin-sidebar-icon">{item.icon}</span>
                <span className="admin-sidebar-text">{item.title}</span>
              </Link>
            )}

          </div>
        ))}

        {/* Logout */}
        <div className="admin-sidebar-menu-item">
          <div
            className="admin-sidebar-link admin-sidebar-logout"
            onClick={handleLogout}
          >
            <span className="admin-sidebar-icon"><FaSignOutAlt /></span>
            <span className="admin-sidebar-text">Logout</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminSidebar;